
import React, { useEffect, useState } from 'react'
import { Col, Gap, Icon, Loading, PageHeader, ReportFooter, Row, Table } from '../../../../components';
import { Link } from 'react-router-dom';
import { iconLeft, iconUser } from '../../../../assets';
import { connect } from 'react-redux'
import API from '../../../../config/api';
import { useDebounce } from '../../../../utils/helpers/useDebounce';
import { Amount, Card, CardContent, Status, TextDate, Title } from '../../../ManajerKeuangan/Dashboard/components/reimbursement';
import ModalDetailReimbursement from './ModalDetailReimbursement';
const RequestReimbursement = (props) => {
    const token = props.user.token;
    const employee = props.user.info;
    const history = props.history;
    const setOpenmodal = props.setOpenmodal;
    const openModal = props.openModal;
    const handlCLose = props.handlCLose;
    const [tableData, setTableData] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [message, setMessage] = useState('');
    const [position, setPosition] = useState(0);
    const [totalPage, setTotalPage] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [stypeModal, setTypeModal] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 800);
    const [totalTableData, setTotalTableData] = useState(0);
    const [data, setData] = useState();
    const [loadingPost, setLoadingPost] = useState(false)
    const [visibleCount, setVisibleCount] = useState(5);

    const handleLoadMore = () => {
        setVisibleCount(prev => prev + 5);
    };
    const handleDelete = (row) => {
        // console.log(row)
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this employee!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    handlCLose()
                    setLoadingPost(true)
                    // console.log('Call API delete Departemen');
                    return API.deleteReimbursement(token, row.id).then(res => {
                        swal({
                            title: 'Berhasil',
                            text: 'Reimbursement berhasil dihapus',
                            icon: "success",
                        });
                        // console.log('call branch Data lagi');
                        //apa supaya tertriger use effectnya
                        getReimbursement()
                        setLoadingPost(false)
                    }).catch(err => {
                        console.log(err);
                        setLoadingPost(false)
                    })
                }
                else {
                }
            });
    }
    const getReimbursement = () => {
        setLoadingPost(true)
        API.getListReimbursement(token, employee?.id, currentPage, perPage, searchTerm).then((res) => {
            console.log('res', res)
            setTableData(res?.data)
            setLoadingPost(false)
            setMessage('success get data employee');
        }).catch(err => {
            // console.log(err.response.data.message);
            // console.log(err);
            setTableData(0);
            setMessage(err.response.data.message || 'Karyawan tidak ditemukan');
            setLoadingPost(false)
        })
    }
    useEffect(() => {
        setTotalPage(0);

        if (searchTerm != '') {
            setCurrentPage(1);
            setPosition(1);
        }
        getReimbursement()
    }, [debouncedSearchTerm, currentPage, perPage, searchTerm])


    const formatRupiah = (number) => {
        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0
        }).format(number);
    };

    const formatTanggalIndonesia = (tanggalString) => {
        const tanggal = new Date(tanggalString);
        return new Intl.DateTimeFormat('id-ID', {
            weekday: 'long',
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        }).format(tanggal);
    };


    return (
        <>
            <PageHeader
                title="Form Pengajuan Reimbursement"
                subtitle={props.user.client_id}
                name={props.user.name}
                photo={iconUser}
            />
            <Gap height={20} />
            <Gap height={20} />
            {tableData?.length > 0 &&
                tableData?.slice(0, visibleCount).map((data, index) => (
                    <Card key={index} onClick={() => {
                        setOpenmodal(true)
                        setData(data)
                    }}>
                        <CardContent>
                            <Title>{data?.title}</Title>
                            <Amount>{formatRupiah(data?.amount)}</Amount>
                        </CardContent>
                        <CardContent>
                            <Status className={data?.status === 'approved' || data?.status === 'paid' ? "approved" : data?.status === 'pending' ? "submitted" : "rejected"}>{data?.status}</Status>
                            <TextDate>{formatTanggalIndonesia(data?.date_incurred)}</TextDate>
                        </CardContent>
                    </Card>
                ))}
            {visibleCount < tableData?.length && (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <button onClick={handleLoadMore} style={{ marginTop: '10px', fontWeight: "600", fontSize: "20px" }}>
                        Load More
                    </button>
                </div>
            )}
            {
                openModal &&
                <ModalDetailReimbursement openModal={openModal} setOpenmodal={setOpenmodal} handlCLose={handlCLose} employee={employee} data={data} setData={setData} setTypeModal={setTypeModal} getTicket={getReimbursement} handleDelete={handleDelete} />
            }
            <div style={{ position: "fixed", top: "0", right: "0", background: "#00000027", zIndex: "10000", display: loadingPost ? "inline" : "none" }}>
                <Loading />
            </div>
        </>
    )
}

const reduxState = (state) => ({
    isLogin: state.isLogin,
    user: state.user,
    isLoading: state.isLoading

})


const reduxDispatch = (dispatch) => ({
    loading: (data) => dispatch(setLoading(data)),



})
export default connect(reduxState, reduxDispatch)(RequestReimbursement)
